// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/bread.svg

import React from 'react';

/** Proporção nativa 24x24. */
export default function IconeBread({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 3c-4.97 0-9 2.24-9 5 0 1.1.7 2.1 1.9 2.9V19a2 2 0 0 0 2 2h10.2a2 2 0 0 0 2-2v-8.1C20.3 10.1 21 9.1 21 8c0-2.76-4.03-5-9-5Z"></path>
    </svg>
  );
}
